import { io } from 'socket.io-client';

// Socket.io will use the same host and protocol as the page
// No need to specify URL if backend is on same domain
export const socket = io({
  autoConnect: true,
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: 5,
});

// Connection event handlers
socket.on('connect', () => {
  console.log('Socket.io connected:', socket.id);
});

socket.on('disconnect', (reason) => {
  console.log('Socket.io disconnected:', reason);
});

socket.on('connect_error', (error) => {
  console.error('Socket.io connection error:', error);
});

socket.on('reconnect', (attemptNumber) => {
  console.log('Socket.io reconnected after', attemptNumber, 'attempts');
});

socket.on('reconnect_error', (error) => {
  console.error('Socket.io reconnection error:', error);
});

socket.on('reconnect_failed', () => {
  console.error('Socket.io reconnection failed');
});
